// extracted by mini-css-extract-plugin
export default {"imageContainer":"haa-z","summaryPar":"iaa-z","ratingCategories":"jaa-z","reviewerInfo":"kaa-z","reviewTypes":"laa-z","expanded":"maa-z"};